function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createAction } from 'redux-actions';
import initialState from './initialState';
import formatActionTypeNames from '../helpers/formatActionTypeNames';
export var actions = formatActionTypeNames({
  boot: 'BOOT',
  booted: 'BOOTED',
  contactUsBubble: 'CONTACT_US_BUBBLE',
  gaEvent: 'GA_EVENT',
  gaPageView: 'GA_PAGE_VIEW',
  setState: 'SET_STATE',
  toggleHamburgerMenu: 'TOGGLE_HAMBURGER_MENU'
}, 'APP');
export var appActions = {
  boot: createAction(actions.boot),
  booted: createAction(actions.booted),
  contactUsBubble: createAction(actions.contactUsBubble),
  gaEvent: createAction(actions.gaEvent),
  gaPageView: createAction(actions.gaPageView),
  setState: createAction(actions.setState),
  toggleHamburgerMenu: createAction(actions.toggleHamburgerMenu)
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.app;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var payload = action.payload;
  switch (action.type) {
    case actions.booted:
      return _objectSpread(_objectSpread({}, state), {}, {
        navigation: payload.navigation,
        booted: true
      });
    case actions.setState:
      return _objectSpread(_objectSpread({}, state), payload);
    case actions.toggleHamburgerMenu:
      return _objectSpread(_objectSpread({}, state), {}, {
        toggleHamburgerMenu: payload === false ? false : uuid()
      });
    default:
      return state;
  }
});